export enum EBitfCloseEventStatus {
  OK,
  CANCEL,
  CLOSE,
  ERROR
}
